import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { login } from "../../../api/Login";
import * as actions from "../../../actions";
import { withRouter } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { saveUserEntry } from "../../../api/User";
import { LoadingSpinner } from "../../../components";

class MemberLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      loginId: "",
      password: "",
      isLoading: false,
    };
  }

  updateState(prop, value) {
    this.setState({ [prop]: value, errorMessage: "" });
  }

  validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  validate() {
    const { loginId, password } = this.state;
    if (loginId === "" || password === "") {
      this.setState({ errorMessage: "Please enter both email and password." });
      return false;
    }
    if (!this.validateEmail(loginId)) {
      this.setState({ errorMessage: "Please enter a valid email address." });
      return false;
    }
    return true;
  }

  goToNextPage = () => {
    // Return the user to the page they came from, defaulting to /home
    const redirectTo = (this.props.location.state && this.props.location.state.from) || "/home";
    this.props.history.push({ pathname: redirectTo });
  };

  submitHandle = async (e) => {
    e.preventDefault();
    if (this.validate() === false) return;
    this.setState({ isLoading: true, errorMessage: "" });

    let response = await login(this.state, "");
    if (response && response.status) {
      let user = response.data;
      user.loginMethod = "email";
      this.props.keepUser(user);
      this.setState({ isLoading: false });
      this.goToNextPage();
    } else {
      this.setState({
        errorMessage: (response && response.message) || "Invalid email or password",
        isLoading: false,
      });
    }
  };

  continueAsGuest = () => {
    this.goToNextPage();
  };

  goToRegister = () => {
    this.props.history.push({ pathname: "/register" });
  };

  handleGoogleSuccess = async (credentialResponse) => {
    const decoded = jwtDecode(credentialResponse.credential);

    if (decoded.email_verified) {
      let password = "sub-" + decoded.sub;
      let data = {
        userID: 0,
        userName: decoded.name,
        password: password,
        phNo: "",
        loginId: decoded.email,
        role: { label: "User", value: 3 },
        address: "",
        isActive: true,
        hasToCheckPwd: false,
        masterSim: null,
        epinMasterSim: { label: "Not Selected", value: 0 },
        beforeMS: null,
        beforeEpinMS: null,
        masterSimEpin: null,
        IsEload: "Station",
        creditLimit: 0,
        preCreditlimit: 0,
        creditBalance: 0,
        salePersonUserId: { label: "Not Selected", value: 0 },
        paidType: { label: "Prepaid", value: "prepaid" },
        isPrepaid: "",
        profile: "",
        profileToDelete: "",
      };
      // companyId 1 is default for production
      var res = await saveUserEntry(data, 1);
      const userInfo = { loginId: data.loginId, password: data.password };

      if (res.status || res.message === "This user is already existed") {
        let response = await login(userInfo, "");
        let user = response && response.data;
        if (response && response.status && user && user.isAuth) {
          user.loginMethod = "email";
          this.props.keepUser(user);
          this.goToNextPage();
        } else {
          this.setState({ errorMessage: (response && response.message) || "Google sign-in failed", isLoading: false });
        }
      } else {
        this.setState({ isLoading: false, errorMessage: res.message });
      }
    }
  };

  render() {
    const { errorMessage, loginId, password, isLoading } = this.state;
    return (
      <div className="app d-flex align-items-center justify-content-center min-vh-100">
        {isLoading && <LoadingSpinner />}
        <Container>
          <Row className="justify-content-center">
            <Col md="6" lg="5">
              <div className="text-center mb-4">
                <img
                  src={`${process.env.PUBLIC_URL}/SeaFarerInternetService_2.png`}
                  width="200"
                  height="auto"
                  alt="ESM"
                />
              </div>

              {errorMessage !== "" && <Alert color="danger">{errorMessage}</Alert>}

              <Card className="p-4">
                <CardBody>
                  <h2 className="mb-4 text-center">Sign in</h2>

                  <form onSubmit={this.submitHandle}>
                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fa fa-envelope-o"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        autoFocus
                        type="email"
                        name="loginId"
                        value={loginId}
                        onChange={(e) => this.updateState("loginId", e.target.value)}
                        placeholder="Email Address"
                      />
                    </InputGroup>

                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fa fa-lock fa-lg"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="password"
                        name="password"
                        value={password}
                        onChange={(e) => this.updateState("password", e.target.value)}
                        placeholder="Password"
                      />
                    </InputGroup>

                    <Button color="primary" block type="submit" className="mb-3">
                      Login
                    </Button>
                  </form>

                  <div className="text-center mb-3" style={{ color: "#999" }}>
                    — or —
                  </div>

                  <div className="google-btn-wrapper text-center mb-3">
                    <GoogleLogin
                      shape="pill"
                      onSuccess={this.handleGoogleSuccess}
                      onError={() => {
                        console.log("Google Sign-In failed");
                      }}
                      auto_select={true}
                    />
                  </div>

                  <div className="text-center">
                    <Button color="link" className="px-0" onClick={this.continueAsGuest}>
                      Continue as Guest
                    </Button>
                  </div>
                  <div className="text-center">
                    <span style={{ color: "#777" }}>New here? </span>
                    <Button color="link" className="px-0" onClick={this.goToRegister}>
                      Create an account
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return { auth: state.auth };
}

export default connect(mapStateToProps, actions)(withRouter(MemberLogin));